import { useEffect, useState } from "react";
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Form,
  DatePicker,
  List,
} from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

const ViewBranchForm = ({
  parentBranch = [],
  officeTypeOptions = [],
  nearestBranchOptions = [],
  countryIdData = [],
  stateProvinceIdData = [],
  addressTypeIdData = [],
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchKey,
}) => {
  const [form] = Form.useForm();
  const [addressList, setAddressList] = useState([]);

  useEffect(() => {
    getBranchById(selectedBranchKey.id);
    getAddressById(selectedBranchKey.id);
  }, []);

  const getBranchById = (id) => {
    const url = `${apiConfig.OfficeOutlet}/${id}`;

    setIsLoading(true);
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const {
          name,
          externalId,
          openingDate,
          parentId,
          officeTypeId,
          nearestBranchId,
        } = res;

        const date = Array.isArray(openingDate)
          ? dayjs(new Date(openingDate[0], openingDate[1] - 1, openingDate[2]))
          : dayjs();

        form.setFieldsValue({
          name,
          externalId,
          openedOn: date,
          parentBranch: parentId || parentBranch[0]?.value,
          officeTypeId: officeTypeId || undefined,
          nearestBranchId: nearestBranchId || undefined,
        });

        setIsLoading(false);
      }
    });
  };

  const getAddressById = (id) => {
    const url = `${apiConfig.AddressOffice}/${id}/addresses`;

    setIsLoading(true);
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        if (Array.isArray(res) && res.length > 0) {
          const mapped = res.map((addr) => ({
            id: addr.addressId,
            title: addr.addressType,
            description: `${addr.addressLine1}${addr.addressLine2 ? ", " + addr.addressLine2 : ""}, ${addr.city}, ${addr.stateName}, ${addr.countryName}${addr.postalCode ? ", " + addr.postalCode : ""}`,
            addressLine1: addr.addressLine1,
            addressLine2: addr.addressLine2,
            street: addr.street,
            addressTypeId: addr.addressTypeId,
            city: addr.city,
            countryId: addr.countryId,
            isActive: addr.isActive,
            postalCode: addr.postalCode,
            stateProvinceId: addr.stateProvinceId,
          }));
          setAddressList(mapped);
        }

        setIsLoading(false);
      }
    });
  };

  return (
    <Form form={form} layout="vertical" style={{ paddingTop: 20 }}>
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginBottom: 24,
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#9ca3af",
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
        >
          Branch Information
        </div>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="name" label={<Text strong>Branch</Text>}>
              <Input
                placeholder="—"
                style={{ height: 44 }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="parentBranch"
              label={<Text strong>Parent Branch</Text>}
            >
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={parentBranch}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="officeTypeId"
              label={<Text strong>Office Type</Text>}
            >
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={officeTypeOptions}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="openedOn" label={<Text strong>Opened On</Text>}>
              <DatePicker
                style={{ width: "100%", height: 44 }}
                format="DD MMMM YYYY"
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="externalId"
              label={<Text strong>Branch Code</Text>}
            >
              <Input
                placeholder="—"
                style={{ height: 44 }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="nearestBranchId"
              label={<Text strong>Nearest Branch</Text>}
            >
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={nearestBranchOptions}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#9ca3af",
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
        >
          Address Information
        </div>

        {addressList.length > 0 ? (
          <List
            dataSource={addressList}
            renderItem={(item) => (
              <Card
                style={{
                  width: "100%",
                  marginBottom: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                }}
                bodyStyle={{ padding: "12px 16px" }}
              >
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>
                  {item.title?.toUpperCase()}
                </div>
                <div style={{ color: "#6b7280", fontSize: 13 }}>
                  {item.description}
                </div>
              </Card>
            )}
          />
        ) : (
          <div
            style={{
              padding: "24px 16px",
              textAlign: "center",
              color: "#9ca3af",
              fontSize: 13,
              border: "1px dashed #e5e7eb",
              borderRadius: 12,
            }}
          >
            No addresses found for this branch
          </div>
        )}
      </Card>
    </Form>
  );
};

export default ViewBranchForm;
